import React from 'react';

export type AgentDownloadButtonVariant = 'primary' | 'link';

export interface AgentDownloadButtonProps {
  variant?: AgentDownloadButtonVariant;
}

const SIGNALBRIDGE_DEFAULT_DOWNLOAD_URL =
  'https://canalerts-agent-downloads.s3.us-east-1.amazonaws.com/signalbridge-agent/signalbridge-agent-win-x64-1.0.0.zip';

export const resolveAgentDownloadUrl = (): string => {
  const env = (import.meta as any).env || {};
  const signalBridgeUrl = String(env['VITE_SIGNALBRIDGE_AGENT_DOWNLOAD_URL'] || '').trim();

  if (signalBridgeUrl) {
    return signalBridgeUrl;
  }

  return SIGNALBRIDGE_DEFAULT_DOWNLOAD_URL;
};

export const resolveAgentDownloadFileName = (url: string): string => {
  try {
    const parsed = new URL(url);
    const pathname = String(parsed.pathname || '').trim();
    const segments = pathname.split('/').filter(Boolean);
    return segments.length ? segments[segments.length - 1] : 'agent-download.zip';
  } catch (_) {
    const segments = String(url || '').split('/').filter(Boolean);
    return segments.length ? segments[segments.length - 1] : 'agent-download.zip';
  }
};

export const AgentDownloadButton: React.FC<AgentDownloadButtonProps> = ({
  variant = 'primary'
}) => {
  const downloadUrl = resolveAgentDownloadUrl();

  const handleClick = () => {
    window.open(downloadUrl, '_blank', 'noopener,noreferrer');
  };

  if (variant === 'link') {
    return (
      <button
        type="button"
        onClick={handleClick}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          margin: 0,
          color: '#2563eb',
          textDecoration: 'underline',
          cursor: 'pointer',
          font: 'inherit'
        }}
      >
        Download SignalBridge Windows Agent
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.5rem 1rem',
        borderRadius: '0.375rem',
        border: '1px solid #1d4ed8',
        backgroundColor: '#2563eb',
        color: '#ffffff',
        fontWeight: 500,
        cursor: 'pointer'
      }}
    >
      Download SignalBridge Windows Agent
    </button>
  );
};
